import type { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

type UploadAvatarPath = paths['/v2/users/me/avatar']['post'];

type UploadAvatarRequestBody = UploadAvatarPath['requestBody']['content']['multipart/form-data'];

type UploadAvatarResponse = UploadAvatarPath['responses']['200']['content']['application/json'];

/** Sends the file as multipart form data, the encoding the endpoint reads it from. */
function toFormData(body: UploadAvatarRequestBody): FormData {
  const formData = new FormData();

  formData.append('avatar', body.avatar);

  return formData;
}

export async function uploadAvatar(
  request: UploadAvatarRequestBody
): Promise<UploadAvatarResponse['data']> {
  const { data } = await fetchClient.POST('/v2/users/me/avatar', {
    body: request,
    bodySerializer: toFormData,
  });

  if (!data) {
    throw new Error('No response data received');
  }

  return data.data;
}
